export const servicesCardsMock = [
  {
    title: "Automated Business & Process Workflows",
    descriptions: [
      "Workflow Automation & Integration",
      "n8n Intelligent Workflows",
      "Intelligent Process Automation",
      "Automated Agent Actions",
    ],
  },
  {
    title: "Secure & Scalable AI Architecture",
    descriptions: [
      "Retrieval-Augmented Generation (RAG)",
      "Semantic Search & Vector Databases (Milvus, Faiss)",
      "On-Premise & Compliant Cloud Deployment",
      "GDPR & Data Sovereignty",
    ],
  },
  {
    title: "Advanced Model Customization & R&D",
    descriptions: [
      "LLM Fine-Tuning (LoRA/QLoRA)",
      "Custom Hallucination Detection",
      "Deep Reinforcement Learning (DRL)",
      "Foundation Models (GPT-4, Llama, Mistral)",
    ],
  },
  {
    title: "Chatbot Systems & Intelligent Knowledge ",
    descriptions: [
      "AI Agents & Multi-Agent Systems (LangGraph, Autogen)",
      "GenAI & Knowledge Chatbots",
      "Voice-Enabled Bots & IVR Systems",
      "Custom Tooling & Function Calling",
    ],
  },
];
